export default __webpack_public_path__ + "static/media/email.2e302aa5.svg";